/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
    Custom Quick Add - Size Selector Handler
   */
  function initCustomQuickAddSizeSelector() {
    const sizeSelectors = document.querySelectorAll('[data-custom-size-select]');
    
    sizeSelectors.forEach((selector) => {
      selector.addEventListener('change', function() {
        const container = this.closest('.custom-quick-add__container');
        if (!container) return;

        const selectedOption = this.options[this.selectedIndex];
        const variantId = selectedOption.value;
        const variantAvailable = selectedOption.dataset.variantAvailable === 'true';
        const atcButton = container.querySelector('atc-button');
        const btnText = atcButton?.querySelector('.btn__text');
        const form = container.querySelector('form');

        if (!variantId || variantId === '') {
          // No variant selected
          if (atcButton) {
            atcButton.disabled = true;
            atcButton.classList.add('custom-atc-button--soldout');
            if (btnText) {
              btnText.textContent = atcButton.getAttribute('data-sold-out-text') || 'Select size';
            }
          }
          if (form) {
            const select = form.querySelector('[name="id"]');
            if (select) select.value = '';
          }
          return;
        }

        // Update button
        if (atcButton) {
          atcButton.dataset.variantId = variantId;
          
          // Update button availability state
          if (variantAvailable) {
            atcButton.disabled = false;
            atcButton.classList.remove('custom-atc-button--soldout');
            container.classList.remove('variant--soldout');
            
            // Update button text
            const isPreorder = atcButton.dataset.preorder === 'true';
            if (btnText) {
              if (isPreorder) {
                btnText.textContent = atcButton.getAttribute('data-preorder-text') || atcButton.getAttribute('aria-label') || 'Pre-order';
              } else {
                btnText.textContent = atcButton.getAttribute('data-add-to-cart-text') || atcButton.getAttribute('aria-label') || 'Add to cart';
              }
            }
          } else {
            atcButton.disabled = true;
            atcButton.classList.add('custom-atc-button--soldout');
            container.classList.add('variant--soldout');
            if (btnText) {
              btnText.textContent = atcButton.getAttribute('data-sold-out-text') || 'Sold out';
            }
          }
        }
      });
    });
  }

  /**
   * Custom ATC Button Element - Dispatches theme:cart:add event to work with existing CartItems logic
   */
  class AtcButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Store original text content for dynamic updates
      const btnText = this.querySelector('.btn__text');
      if (btnText) {
        const text = btnText.textContent.trim();
        // Store original texts for later use
        if (text.toLowerCase().includes('pre-order') || text.toLowerCase().includes('forudbestil')) {
          this.setAttribute('data-preorder-text', text);
        } else if (text.toLowerCase().includes('add to cart') || text.toLowerCase().includes('tilføj til kurv')) {
          this.setAttribute('data-add-to-cart-text', text);
        } else if (text.toLowerCase().includes('sold out') || text.toLowerCase().includes('udsolgt')) {
          this.setAttribute('data-sold-out-text', text);
        }
      }

      // Add click event listener (use stored bound ref to avoid duplicates on re-insertion)
      if (!this._boundClick) {
        this._boundClick = this.handleClick.bind(this);
      }
      this.addEventListener('click', this._boundClick);
    }

    disconnectedCallback() {
      if (this._boundClick) {
        this.removeEventListener('click', this._boundClick);
      }
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      // Check if button is disabled - the cart system checks hasAttribute('disabled')
      if (this.hasAttribute('disabled')) {
        return;
      }

      // Get form
      const form = this.closest('form');
      
      if (!form) {
        console.error('atc-button must be inside a form');
        return;
      }

      // Get variant ID from select
      const sizeSelect = form.querySelector('[data-custom-size-select]');
      const variantId = sizeSelect ? sizeSelect.value : this.dataset.variantId;

      // Validate that a variant is selected
      if (!variantId || variantId === '') {
        if (sizeSelect) {
          sizeSelect.reportValidity();
          sizeSelect.focus();
        }
        return;
      }

      // Ensure form has the correct variant ID - this is critical for FormData
      const formSelect = form.querySelector('[name="id"]');
      if (formSelect) {
        formSelect.value = variantId;
      }

      // Dispatch theme:cart:add event (handled by CartItems.cartAddEvent)
      // The cart system expects event.detail.button to be the button element
      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: this,
          },
          bubbles: true,
        })
      );
    }
  }

  // Initialize on DOM ready
  function init() {
    // Define custom element first
    if (!customElements.get('atc-button')) {
      customElements.define('atc-button', AtcButton);
    }
    
    initCustomQuickAddSizeSelector();
    
    // Ensure forms have correct initial variant ID values
    document.querySelectorAll('.custom-quick-add__form').forEach((form) => {
      const select = form.querySelector('[data-custom-size-select]');
      const formSelect = form.querySelector('[name="id"]');
      if (select && formSelect && select.value) {
        formSelect.value = select.value;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize for dynamically added content
  document.addEventListener('theme:cart:refresh', function() {
    setTimeout(initCustomQuickAddSizeSelector, 100);
    setTimeout(initializeLazyQuickAdd, 100);
  });

  /**
   * Lazy Quick Add — Progressive Select Enhancement
   *
   * The Liquid snippet renders a real working form with only the FIRST
   * available variant in the <select>. The ATC button works immediately.
   *
   * When the user opens the <select> dropdown (mousedown / focus / touchstart),
   * we fetch /products/{handle}.js and populate the remaining <option> elements.
   * This saves ~1–2 KB of HTML per product card on initial page load.
   */
  const lazyQuickAddCache = new Map();

  function populateSelectOptions(select, productData, currentVariantId) {
    // Avoid double-population
    if (select.dataset.lazyLoaded === 'true') return;
    select.dataset.lazyLoaded = 'true';

    const availableVariants = productData.variants.filter(function(v) { return v.available; });

    // Clear existing options and rebuild with all available variants
    select.innerHTML = '';
    availableVariants.forEach(function(variant) {
      const option = document.createElement('option');
      option.value = variant.id;
      option.dataset.variantId = variant.id;
      option.dataset.variantAvailable = 'true';
      option.textContent = variant.option2 || variant.title;
      if (String(variant.id) === String(currentVariantId)) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    // Update single-option class
    if (availableVariants.length === 1) {
      select.classList.add('single-option');
    } else {
      select.classList.remove('single-option');
    }
  }

  function fetchAndPopulateSelect(container) {
    const select = container.querySelector('[data-lazy-select]');
    if (!select || select.dataset.lazyLoaded === 'true') return;

    const handle = container.dataset.productHandle;
    const currentVariantId = select.value;

    // Mark as loading so we don't fire multiple requests
    select.dataset.lazyLoading = 'true';

    // Check cache first
    const cached = lazyQuickAddCache.get(handle);
    if (cached) {
      populateSelectOptions(select, cached, currentVariantId);
      return;
    }

    // Fetch product JSON
    fetch(window.theme.routes.root + 'products/' + handle + '.js')
      .then(function(response) {
        if (!response.ok) throw new Error('Product fetch failed: ' + response.status);
        return response.json();
      })
      .then(function(productData) {
        lazyQuickAddCache.set(handle, productData);
        populateSelectOptions(select, productData, currentVariantId);
      })
      .catch(function(err) {
        console.error('Lazy Quick Add fetch error:', err);
        select.dataset.lazyLoading = 'false';
      });
  }

  function initializeLazyQuickAdd() {
    document.querySelectorAll('[data-lazy-quick-add]').forEach(function(container) {
      // Skip already-initialized containers
      if (container.dataset.lazyInitialized) return;
      container.dataset.lazyInitialized = 'true';

      const select = container.querySelector('[data-lazy-select]');
      if (!select) return;

      // Only 1 available variant — nothing to lazy-load, form already works
      const availableCount = parseInt(container.dataset.availableCount, 10) || 0;
      if (availableCount <= 1) return;

      // Track touch events so we can distinguish touch-originated mousedown
      // from real mouse clicks. On mobile, mousedown fires after touchstart
      // but we must NOT preventDefault() on it — that kills the native dropdown.
      let lastTouchTime = 0;

      // --- Prefetch strategy ---
      // Start fetching product data IMMEDIATELY when the card is initialized.
      // This gives maximum lead time — by the time the user can physically
      // move their cursor to click the <select>, the data is already cached.
      //
      // This is critical for Safari desktop where mutating <select> options
      // during mousedown kills the native dropdown. The data MUST be cached
      // (synchronous populate) before the dropdown opens.
      //
      // Additional layers (mouseenter, touchstart) serve as fallbacks in case
      // the initial fetch failed or was slow.
      const prefetchHandler = function() {
        if (select.dataset.lazyLoaded === 'true' || select.dataset.lazyLoading === 'true') return;
        const handle = container.dataset.productHandle;
        if (lazyQuickAddCache.has(handle)) return;
        // Fire-and-forget fetch to warm the cache
        select.dataset.lazyLoading = 'true';
        fetch(window.theme.routes.root + 'products/' + handle + '.js')
          .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function(data) { lazyQuickAddCache.set(handle, data); })
          .catch(function() { select.dataset.lazyLoading = 'false'; });
      };

      // Start prefetch immediately on initialization
      // For collection pages: fires on DOMContentLoaded (cards are in initial HTML)
      // For recently-viewed: fires when MutationObserver detects card injection
      prefetchHandler();

      // Fallback: mouseenter/pointerenter hover triggers prefetch if initial fetch failed
      container.addEventListener('mouseenter', prefetchHandler);
      container.addEventListener('pointerenter', prefetchHandler);

      // Also prefetch when hovering the parent product card (more lead time)
      const productCard = container.closest('[data-grid-item], .product-item, .product-grid-item');
      if (productCard) {
        productCard.addEventListener('mouseenter', prefetchHandler);
      }

      // touchstart prefetch for mobile (finger down on card)
      container.addEventListener('touchstart', function() {
        lastTouchTime = Date.now();
        prefetchHandler();
      }, { passive: true });

      // --- Populate on select interaction ---
      // When the user actually clicks/focuses the <select>, populate from cache if ready.
      // If cache miss (fast click before hover fetch completes), fetch + populate
      // but defer the DOM mutation so Safari's native dropdown isn't killed.
      const populateHandler = function(e) {
        if (select.dataset.lazyLoaded === 'true') return;

        // On mobile, mousedown fires after touchstart. Skip it — the touchstart
        // handler on the select already started the fetch, and preventDefault()
        // would block the native dropdown from opening on first tap.
        if (Date.now() - lastTouchTime < 800) return;

        const handle = container.dataset.productHandle;
        const currentVariantId = select.value;
        const cached = lazyQuickAddCache.get(handle);

        if (cached) {
          // Cache hit — populate synchronously (safe: data was prefetched before click)
          populateSelectOptions(select, cached, currentVariantId);
          return;
        }

        // Cache miss (desktop only — clicked before hover prefetch completed).
        // On Safari, mutating <select> during mousedown kills the dropdown,
        // so we prevent the dropdown from opening, fetch, populate, then
        // programmatically re-open it.
        e.preventDefault();
        fetchAndPopulateSelect(container);
        // After fetch completes, try to re-open the dropdown
        const checkReady = setInterval(function() {
          if (select.dataset.lazyLoaded === 'true') {
            clearInterval(checkReady);
            // showPicker() is supported in Safari 16+, Chrome 99+, Firefox (no)
            if (typeof select.showPicker === 'function') {
              try { select.showPicker(); } catch(err) { /* user gesture may have expired */ }
            }
          }
        }, 50);
        // Give up after 3s
        setTimeout(function() { clearInterval(checkReady); }, 3000);
      };

      select.addEventListener('mousedown', populateHandler);
      select.addEventListener('focus', function() {
        if (select.dataset.lazyLoaded === 'true') return;
        fetchAndPopulateSelect(container);
      });
      // Mobile: touchstart on the select starts fetch. The native dropdown
      // opens with the single pre-rendered option. On next tap, all options
      // are populated from cache.
      select.addEventListener('touchstart', function() {
        lastTouchTime = Date.now();
        if (select.dataset.lazyLoaded === 'true') return;
        fetchAndPopulateSelect(container);
      }, { passive: true });
    });
  }

  // Initialize lazy Quick Add on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLazyQuickAdd);
  } else {
    initializeLazyQuickAdd();
  }

  // Re-init for dynamically loaded content (infinite scroll, AJAX filters, tab changes, etc.)
  document.addEventListener('theme:tab:change', function() {
    setTimeout(initializeLazyQuickAdd, 100);
  });
  document.addEventListener('theme:complementary:loaded', function() {
    setTimeout(initializeLazyQuickAdd, 100);
  });

  // MutationObserver to catch infinite scroll / AJAX-injected product cards
  (function() {
    const lazyQuickAddObserver = new MutationObserver(function(mutations) {
      let hasNewLazy = false;
      for (let i = 0; i < mutations.length; i++) {
        const added = mutations[i].addedNodes;
        for (let j = 0; j < added.length; j++) {
          const node = added[j];
          if (node.nodeType === 1) {
            if (node.hasAttribute && node.hasAttribute('data-lazy-quick-add')) {
              hasNewLazy = true;
              break;
            }
            if (node.querySelector && node.querySelector('[data-lazy-quick-add]')) {
              hasNewLazy = true;
              break;
            }
          }
        }
        if (hasNewLazy) break;
      }
      if (hasNewLazy) {
        initializeLazyQuickAdd();
      }
    });
    lazyQuickAddObserver.observe(document.body, { childList: true, subtree: true });
  })();

  // Expose globally for Wishlist and other integrations
  window.initializeLazyQuickAdd = initializeLazyQuickAdd;

  /**
   * Lazy Variant Images — On-Demand Swatch Image Loading
   *
   * Instead of pre-rendering a hidden <div> with a full <img srcset="...">
   * for every unique variant image (which added ~400–500 bytes of HTML per
   * variant per product card), we now create <img> elements on demand when
   * a color swatch is hovered.
   *
   * The grid-swatch custom element (theme.js) already sets data-swatch-image
   * on each swatch button with the CDN URL. We hook into the same mouseenter
   * event to dynamically create and cache <img> elements.
   *
   * - First hover on a color: browser fetches the image from CDN (~50–200ms)
   * - Subsequent hovers: instant (cached <img> element toggled via CSS class)
   *
   * This mirrors the existing sibling image system (showSiblingImage in theme.js)
   * which already works this way.
   */

  var LAZY_VARIANT_VISIBLE_CLASS = 'is-visible';
  var LAZY_VARIANT_FADE_CLASS = 'is-fade';

  /**
   * Calculates the appropriate Shopify CDN image URL for the current card width.
   * Uses the same 180px-step sizing as the sibling image system in theme.js.
   *
   * @param {string} originalUrl - Full CDN URL from data-swatch-image
   * @param {number} containerWidth - Width of the product image container in px
   * @returns {string} - Resized CDN URL with _WIDTHx suffix
   */
  function getResizedImageUrl(originalUrl, containerWidth) {
    var pixelRatio = window.devicePixelRatio || 1;
    var targetWidth = Math.ceil((containerWidth * pixelRatio) / 180) * 180;

    // Shopify CDN: insert _WIDTHx before file extension
    // Handles .jpg, .jpeg, .png, .gif, .webp, etc.
    var extensionMatch = originalUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (!extensionMatch) return originalUrl;

    var parts = originalUrl.split(extensionMatch[0]);
    var ext = extensionMatch[0];

    // Remove any existing _WIDTHx suffix (in case URL already has one)
    var cleanBase = parts[0].replace(/_\d+x(@\dx)?$/, '');

    return cleanBase + '_' + targetWidth + 'x' + ext;
  }

  /**
   * Creates an <img> element for a variant image, appends it to the container,
   * and returns it. The image starts hidden and fades in once loaded.
   *
   * @param {string} resizedUrl - The sized CDN URL
   * @param {string} variantName - Variant title (for alt text and lookup)
   * @param {HTMLElement} imageContainer - The [data-product-image-default] div
   * @returns {HTMLImageElement} - The created <img> element
   */
  function createVariantImageElement(resizedUrl, variantName, imageContainer) {
    var wrapper = document.createElement('div');
    wrapper.className = 'product-item__bg__inner';
    wrapper.setAttribute('data-variant-title', variantName);
    wrapper.setAttribute('data-lazy-variant-image', '');

    var img = document.createElement('img');
    img.src = resizedUrl;
    img.alt = variantName;
    img.className = 'fit-cover';
    img.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;';
    img.loading = 'lazy';

    wrapper.appendChild(img);
    imageContainer.appendChild(wrapper);

    return wrapper;
  }

  /**
   * Finds an existing lazily-created wrapper for a given variant name,
   * or returns null if not yet created.
   *
   * @param {HTMLElement} imageContainer - The [data-product-image-default] div
   * @param {string} variantName - The variant title to match
   * @returns {HTMLElement|null}
   */
  function findCachedVariantWrapper(imageContainer, variantName) {
    return imageContainer.querySelector(
      '[data-lazy-variant-image][data-variant-title="' + variantName + '"]'
    );
  }

  /**
   * Hides all lazily-created variant image wrappers inside a container.
   *
   * @param {HTMLElement} imageContainer - The [data-product-image-default] div
   */
  function hideAllLazyVariantImages(imageContainer) {
    var wrappers = imageContainer.querySelectorAll('[data-lazy-variant-image].' + LAZY_VARIANT_VISIBLE_CLASS);
    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i].classList.remove(LAZY_VARIANT_VISIBLE_CLASS);
      wrappers[i].classList.remove(LAZY_VARIANT_FADE_CLASS);
    }
  }

  /**
   * Shows a variant image for a swatch hover. Creates the <img> on first
   * hover, reuses it on subsequent hovers.
   *
   * @param {HTMLElement} swatchButton - The hovered swatch button element
   * @param {HTMLElement} imageContainer - The [data-product-image-default] div
   */
  function showLazyVariantImage(swatchButton, imageContainer) {
    var imageUrl = swatchButton.getAttribute('data-swatch-image');
    var variantName = swatchButton.getAttribute('data-swatch-variant-name');

    if (!imageUrl || !variantName) return;

    // Hide any currently visible variant images
    hideAllLazyVariantImages(imageContainer);

    // Check for a cached wrapper first
    var existingWrapper = findCachedVariantWrapper(imageContainer, variantName);
    if (existingWrapper) {
      existingWrapper.classList.add(LAZY_VARIANT_VISIBLE_CLASS);
      existingWrapper.classList.add(LAZY_VARIANT_FADE_CLASS);
      return;
    }

    // Create new image element
    var containerWidth = imageContainer.offsetWidth;
    var resizedUrl = getResizedImageUrl(imageUrl, containerWidth);
    var wrapper = createVariantImageElement(resizedUrl, variantName, imageContainer);

    // Show immediately (image may flash in, but CDN is fast)
    var img = wrapper.querySelector('img');
    img.addEventListener('load', function() {
      wrapper.classList.add(LAZY_VARIANT_VISIBLE_CLASS);
      wrapper.classList.add(LAZY_VARIANT_FADE_CLASS);
    });

    // If image is already cached by the browser, load fires synchronously
    if (img.complete) {
      wrapper.classList.add(LAZY_VARIANT_VISIBLE_CLASS);
      wrapper.classList.add(LAZY_VARIANT_FADE_CLASS);
    }
  }

  /**
   * Initializes lazy variant image behavior for all grid-swatch elements.
   * Hooks into the existing swatch button mouseenter events to show images
   * on demand instead of relying on pre-rendered hidden divs.
   *
   * Safe to call multiple times — already-initialized swatch groups are skipped.
   */
  function initializeLazyVariantImages() {
    var swatchFieldsets = document.querySelectorAll('[data-grid-swatch-fieldset]');

    swatchFieldsets.forEach(function(fieldset) {
      // Skip already-initialized fieldsets
      if (fieldset.hasAttribute('data-lazy-variant-initialized')) return;
      fieldset.setAttribute('data-lazy-variant-initialized', '');

      var productItem = fieldset.closest('[data-grid-item]');
      if (!productItem) return;

      var imageContainer = productItem.querySelector('[data-product-image-default]');
      if (!imageContainer) return;

      // Use event delegation on the fieldset for all swatch buttons
      fieldset.addEventListener('mouseenter', function(e) {
        var swatchButton = e.target.closest('[data-swatch-button]');
        if (!swatchButton) return;
        showLazyVariantImage(swatchButton, imageContainer);
      }, true); // Use capture phase to fire before theme.js handler

      // Clean up on product card mouseleave
      productItem.addEventListener('mouseleave', function() {
        hideAllLazyVariantImages(imageContainer);
      });
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLazyVariantImages);
  } else {
    initializeLazyVariantImages();
  }

  // Re-init for dynamically loaded content
  document.addEventListener('theme:tab:change', function() {
    setTimeout(initializeLazyVariantImages, 100);
  });
  document.addEventListener('theme:complementary:loaded', function() {
    setTimeout(initializeLazyVariantImages, 100);
  });
  document.addEventListener('theme:cart:refresh', function() {
    setTimeout(initializeLazyVariantImages, 100);
  });

  // MutationObserver for infinite scroll / AJAX-injected cards
  (function() {
    var lazyVariantObserver = new MutationObserver(function(mutations) {
      var hasNewSwatches = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            if (node.hasAttribute && node.hasAttribute('data-grid-swatch-fieldset')) {
              hasNewSwatches = true;
              break;
            }
            if (node.querySelector && node.querySelector('[data-grid-swatch-fieldset]')) {
              hasNewSwatches = true;
              break;
            }
          }
        }
        if (hasNewSwatches) break;
      }
      if (hasNewSwatches) {
        initializeLazyVariantImages();
      }
    });
    lazyVariantObserver.observe(document.body, { childList: true, subtree: true });
  })();

  // Expose globally
  window.initializeLazyVariantImages = initializeLazyVariantImages;

  // Complementary Products - Connect arrow buttons to Flickity
  function initComplementaryArrows() {
    document.querySelectorAll('.complementary-products__arrow').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var container = btn.closest('.hidden-mobile, .hidden-desktop');
        if (!container) return;
        var slider = container.querySelector('slider-component');
        if (!slider || !slider.flkty) return;
        btn.dataset.direction === 'prev' ? slider.flkty.previous() : slider.flkty.next();
      });
    });
  }

  // Re-init custom quick-add size selectors and arrows after complementary products AJAX load
  document.addEventListener('theme:complementary:loaded', function() {
    initCustomQuickAddSizeSelector();
    initComplementaryArrows();
  });

  /**
   * Brands Slider - Initialize Flickity
   */
  function initBrandsSlider() {
    const sliders = document.querySelectorAll('.brands-slider[data-brands-slider]:not(.flickity-enabled)');
    
    sliders.forEach((slider) => {
      // Skip if already initialized
      if (slider.flkty) return;
      
      const section = slider.closest('[data-section-type="brands-slider"]');
      const prevArrow = section?.querySelector('.brands-slider__arrow--prev');
      const nextArrow = section?.querySelector('.brands-slider__arrow--next');
      
      // Initialize Flickity
      const flkty = new window.theme.Flickity(slider, {
        cellSelector: '.brands-slider__page',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: false
      });
      
      // Store instance
      slider.flkty = flkty;
      
      // Connect custom arrows
      if (prevArrow) {
        prevArrow.addEventListener('click', () => flkty.previous());
      }
      if (nextArrow) {
        nextArrow.addEventListener('click', () => flkty.next());
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandsSlider);
  } else {
    initBrandsSlider();
  }
  document.addEventListener('theme:section:load', initBrandsSlider);

  /**
   * Sub Navigation - Unified initialization for Desktop (Flickity) and Mobile (Scroll)
   */
  function initSubNavigation() {
    const sections = document.querySelectorAll('[data-section-type="sub-navigation"]');
    
    sections.forEach((section) => {
      const slider = section.querySelector('[data-sub-nav-slider]');
      const prevArrow = section.querySelector('[data-sub-nav-prev]');
      const nextArrow = section.querySelector('[data-sub-nav-next]');
      
      if (!slider || !prevArrow || !nextArrow) return;

      const isDesktop = window.innerWidth >= 1000;
      const items = slider.querySelectorAll('.sub-navigation__item');
      if (items.length === 0) return;

      // Desktop: Initialize Flickity
      if (isDesktop) {
        if (slider.flkty || slider.classList.contains('flickity-enabled')) return;
        
        const flkty = new window.theme.Flickity(slider, {
          cellSelector: '.sub-navigation__item',
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          watchCSS: true,
          cellAlign: 'left',
          contain: false,
          groupCells: false
        });
        
        slider.flkty = flkty;
        
        // Arrow visibility handlers
        const showArrows = () => {
          prevArrow.classList.add('is-visible');
          nextArrow.classList.add('is-visible');
        };
        const hideArrows = () => {
          prevArrow.classList.remove('is-visible');
          nextArrow.classList.remove('is-visible');
        };
        
        flkty.on('activate', showArrows);
        flkty.on('deactivate', hideArrows);
        prevArrow.addEventListener('click', () => flkty.previous());
        nextArrow.addEventListener('click', () => flkty.next());
        
        if (slider.classList.contains('flickity-enabled')) {
          showArrows();
        }
      }

      // Mobile: Initialize scroll behavior
      else {
        if (slider._mobileInitialized) return;
        slider._mobileInitialized = true;

        // Update arrow visibility based on scroll position
        const updateArrowVisibility = () => {
          const scrollLeft = slider.scrollLeft;
          const maxScroll = slider.scrollWidth - slider.offsetWidth;
          const hasOverflow = slider.scrollWidth > slider.offsetWidth;

          if (!hasOverflow) {
            prevArrow.classList.remove('is-visible');
            nextArrow.classList.remove('is-visible');
            return;
          }

          prevArrow.classList.toggle('is-visible', scrollLeft > 1);
          nextArrow.classList.toggle('is-visible', scrollLeft < maxScroll - 1);
        };

        // Arrow click handlers - scroll to next/previous item (CSS snap handles alignment)
        prevArrow.addEventListener('click', () => {
          const currentScroll = slider.scrollLeft;
          
          if (currentScroll <= 10) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          
          // Find which item is closest to current scroll position
          let closestIndex = 0;
          let closestDistance = Math.abs(items[0].offsetLeft - currentScroll);
          
          items.forEach((item, index) => {
            const distance = Math.abs(item.offsetLeft - currentScroll);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          
          // Scroll to previous item
          if (closestIndex > 0) {
            slider.scrollTo({ left: items[closestIndex - 1].offsetLeft, behavior: 'smooth' });
          } else {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        });

        nextArrow.addEventListener('click', () => {
          const currentScroll = slider.scrollLeft;
          const maxScroll = slider.scrollWidth - slider.offsetWidth;
          
          if (currentScroll >= maxScroll - 10) {
            slider.scrollTo({ left: maxScroll, behavior: 'smooth' });
            return;
          }
          
          // Find which item is closest to current scroll position
          let closestIndex = 0;
          let closestDistance = Math.abs(items[0].offsetLeft - currentScroll);
          
          items.forEach((item, index) => {
            const distance = Math.abs(item.offsetLeft - currentScroll);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          
          // Scroll to next item
          if (closestIndex < items.length - 1) {
            slider.scrollTo({ left: items[closestIndex + 1].offsetLeft, behavior: 'smooth' });
          } else {
            slider.scrollTo({ left: maxScroll, behavior: 'smooth' });
          }
        });

        slider.addEventListener('scroll', updateArrowVisibility, { passive: true });

        updateArrowVisibility();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubNavigation);
  } else {
    requestAnimationFrame(initSubNavigation);
  }
  document.addEventListener('theme:section:load', initSubNavigation);
  
  // Re-initialize on resize to handle desktop/mobile switch
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      document.querySelectorAll('[data-sub-nav-slider]').forEach(slider => {
        if (window.innerWidth >= 1000) {
          delete slider._mobileInitialized;
        }
      });
      initSubNavigation();
    }, 250);
  });

  /**
   * Updates nav active filters when collection filters are applied/removed
   */
  (function() {
    // Set up event delegation for filter links in nav (handles dynamically added elements)
    function setupFilterLinkDelegation() {
      const components = document.querySelectorAll('collection-component[data-section-type="collection"]');
      components.forEach((component) => {
        const collectionNav = component.querySelector('[data-collection-nav]');
        if (!collectionNav) return;
        
        // Use event delegation - listen on nav for clicks on filter links
        collectionNav.addEventListener('click', (e) => {
          const filterLink = e.target.closest('[data-filter-update-url]');
          if (!filterLink) return;
          
          const filterForm = component.querySelector('collection-filters-form');
          if (filterForm && filterForm.filterUpdateFromUrlEvent) {
            e.preventDefault();
            // Create a synthetic event that matches what the custom element expects
            const syntheticEvent = {
              preventDefault: () => e.preventDefault(),
              currentTarget: filterLink,
              target: e.target
            };
            filterForm.filterUpdateFromUrlEvent(syntheticEvent);
          }
        });
      });
    }
    
    // Set up delegation on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupFilterLinkDelegation);
    } else {
      setupFilterLinkDelegation();
    }
    
    // Re-setup on section load (Shopify theme editor)
    document.addEventListener('shopify:section:load', () => {
      setTimeout(setupFilterLinkDelegation, 100);
    });
    
    // Intercept fetch to update nav active filters
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const url = args[0];
      const isCollectionFetch = typeof url === 'string' && 
        url === window.location.pathname + window.location.search;
      
      if (isCollectionFetch) {
        return originalFetch.apply(this, args).then((response) => {
          const clonedResponse = response.clone();
          clonedResponse.text().then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetchedNav = doc.querySelector('[data-collection-nav]');
            
            // Get fetched filters content from either desktop or mobile container
            const fetchedDesktopFilters = fetchedNav?.querySelector('.collection__active__filters-desktop .collection__active__filters');
            const fetchedMobileFilters = fetchedNav?.querySelector('.collection__active__filters-mobile .collection__active__filters');
            const fetchedFiltersContent = fetchedDesktopFilters?.innerHTML || fetchedMobileFilters?.innerHTML || '';
            
            const components = document.querySelectorAll('collection-component[data-section-type="collection"]');
            components.forEach((component) => {
              const collectionNav = component.querySelector('[data-collection-nav]');
              if (!collectionNav) return;
              
              // Update desktop filters
              const desktopContainer = collectionNav.querySelector('.collection__active__filters-desktop');
              const currentDesktopFilters = desktopContainer?.querySelector('.collection__active__filters');
              const popoutGroup = collectionNav?.querySelector('.popout--group');
              const filterButton = popoutGroup?.querySelector('.popout__toggle');
              
              if (popoutGroup && filterButton) {
                if (fetchedFiltersContent.trim()) {
                  if (currentDesktopFilters) {
                    currentDesktopFilters.innerHTML = fetchedFiltersContent;
                  } else if (desktopContainer) {
                    const newFilters = document.createElement('div');
                    newFilters.className = 'collection__active__filters';
                    newFilters.innerHTML = fetchedFiltersContent;
                    desktopContainer.appendChild(newFilters);
                  } else {
                    const newFilters = document.createElement('div');
                    newFilters.className = 'collection__active__filters';
                    newFilters.innerHTML = fetchedFiltersContent;
                    filterButton.after(newFilters);
                  }
                } else if (currentDesktopFilters) {
                  currentDesktopFilters.remove();
                }
              }
              
              // Update mobile filters
              const mobileContainer = collectionNav.querySelector('.collection__active__filters-mobile');
              if (mobileContainer) {
                const currentMobileFilters = mobileContainer.querySelector('.collection__active__filters');
                if (fetchedFiltersContent.trim()) {
                  if (currentMobileFilters) {
                    currentMobileFilters.innerHTML = fetchedFiltersContent;
                  } else {
                    const newFilters = document.createElement('div');
                    newFilters.className = 'collection__active__filters';
                    newFilters.innerHTML = fetchedFiltersContent;
                    mobileContainer.appendChild(newFilters);
                  }
                  mobileContainer.style.display = '';
                } else {
                  mobileContainer.style.display = 'none';
                }
              }
            });
          });
          return response;
        });
      }
      return originalFetch.apply(this, args);
    };
  })();

  /**
   * Size Filter Sorting - Custom sort for "Størrelse" filter
   * Sorts sizes: number+letter (bra sizes), numbers only, then letters only
   */
  function sortSizeFilter() {
    const sizeFilterGroup = document.querySelector('.filter-group--storrelse');
    if (!sizeFilterGroup) return;
    
    const filterList = sizeFilterGroup.querySelector('.collection-nav');
    if (!filterList) return;
    
    const items = Array.from(filterList.querySelectorAll('li'));
    if (items.length === 0) return;
    
    // Check if items are currently expanded before sorting. If any items with data-link-hidden are visible, it's expanded
    const itemsWithDataHidden = items.filter(item => item.hasAttribute('data-link-hidden'));
    const wasExpanded = itemsWithDataHidden.length > 0 && 
      itemsWithDataHidden.some(item => !item.classList.contains('hidden'));
    
    // Get the size value from the label's span
    const getSizeValue = (item) => {
      const label = item.querySelector('label');
      if (!label) return '';
      const span = label.querySelector('span');
      return span ? span.textContent.trim() : label.textContent.trim();
    };
    
    const categorizeSize = (size) => {
      // Number + letter combo (e.g., 65A, 70B, 75GH)
      const numberLetterMatch = size.match(/^(\d+)([A-Z]+)$/i);
      if (numberLetterMatch) {
        return {
          type: 'numberLetter',
          number: parseInt(numberLetterMatch[1], 10),
          letter: numberLetterMatch[2].toUpperCase()
        };
      }
      
      // Numbers only (e.g., 36, 38, 40)
      const numbersOnlyMatch = size.match(/^\d+$/);
      if (numbersOnlyMatch) {
        return {
          type: 'numbersOnly',
          value: parseInt(size, 10)
        };
      }
      
      // Letters only (e.g., XS, S, M, L)
      return {
        type: 'lettersOnly',
        value: size
      };
    };
    
    // Define order for letter-only sizes
    const lettersOnlyOrder = ['XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'XL/XXL'];
    const getLettersOnlyIndex = (size) => {
      const index = lettersOnlyOrder.indexOf(size);
      // Unknown sizes go to end
      return index !== -1 ? index : 999; 
    };
    
    // Sort items
    items.sort((a, b) => {
      const sizeA = getSizeValue(a);
      const sizeB = getSizeValue(b);
      
      const catA = categorizeSize(sizeA);
      const catB = categorizeSize(sizeB);
      
      // Number+letter combos come first
      if (catA.type === 'numberLetter' && catB.type !== 'numberLetter') return -1;
      if (catA.type !== 'numberLetter' && catB.type === 'numberLetter') return 1;
      
      if (catA.type === 'numberLetter' && catB.type === 'numberLetter') {
        // Sort by number first (lowest to highest)
        if (catA.number !== catB.number) {
          return catA.number - catB.number;
        }
        // Then by letter (A-Z)
        return catA.letter.localeCompare(catB.letter);
      }
      
      // Numbers only come second
      if (catA.type === 'numbersOnly' && catB.type !== 'numbersOnly') return -1;
      if (catA.type !== 'numbersOnly' && catB.type === 'numbersOnly') return 1;
      
      if (catA.type === 'numbersOnly' && catB.type === 'numbersOnly') {
        return catA.value - catB.value;
      }
      
      // Letters only come last
      if (catA.type === 'lettersOnly' && catB.type === 'lettersOnly') {
        const indexA = getLettersOnlyIndex(sizeA);
        const indexB = getLettersOnlyIndex(sizeB);
        if (indexA !== indexB) {
          return indexA - indexB;
        }
        // If not in predefined order, sort alphabetically
        return sizeA.localeCompare(sizeB);
      }
      
      return 0;
    });
    
    // Re-insert items in sorted order
    items.forEach(item => {
      filterList.appendChild(item);
    });
    
    // Apply threshold based on sorted order (first 12 visible when collapsed)
    const showMoreThreshold = 12;
    items.forEach((item, index) => {
      if (index < showMoreThreshold) {
        // First 12 items: always visible
        item.classList.remove('hidden');
        item.removeAttribute('data-link-hidden');
      } else {
        // Items beyond threshold: hide if collapsed, show if expanded
        if (wasExpanded) {
          item.classList.remove('hidden');
          item.removeAttribute('data-link-hidden');
        } else {
          item.classList.add('hidden');
          item.setAttribute('data-link-hidden', '');
        }
      }
    });
    
  }

  /**
   * Cup Filter Sorting - Custom sort for "Bra Cup Size" filter
   * Sorts cups alphabetically: A, AA, B, B/C, C ... DD, E ... R
   * Called from the top of sortSizeFilter(), so it runs on the same triggers
   */
  function sortCupFilter() {
    const cupFilterGroup = document.querySelector('input[name="filter.v.m.custom.bra_cup_size"]')?.closest('.filter-group');
    if (!cupFilterGroup) return;

    const filterList = cupFilterGroup.querySelector('.collection-nav');
    if (!filterList) return;

    const items = Array.from(filterList.querySelectorAll('li'));
    if (items.length === 0) return;

    const visibleCount = items.filter(item => !item.hasAttribute('data-link-hidden')).length;
    const wasExpanded = items.some(item => item.hasAttribute('data-link-hidden') && !item.classList.contains('hidden'));

    const getCupValue = (item) => {
      const label = item.querySelector('label');
      if (!label) return '';
      const span = label.querySelector('span');
      return span ? span.textContent.trim() : label.textContent.trim();
    };

    // 'en', not 'da': Danish collation sorts "AA" as Å, after Z.
    items.sort((a, b) => getCupValue(a).localeCompare(getCupValue(b), 'en'));
    items.forEach(item => filterList.appendChild(item));

    items.forEach((item, index) => {
      if (index < visibleCount || wasExpanded) {
        item.classList.remove('hidden');
        item.removeAttribute('data-link-hidden');
      } else {
        item.classList.add('hidden');
        item.setAttribute('data-link-hidden', '');
      }
    });
  }

   /**
   * Bra filters - show 12 values before "Vis flere" (theme default is 10)
   * Must run after sortCupFilter(), otherwise the cup filter keeps the theme's 10
   */
  function showTwelveInBraFilters() {
    ['filter.v.m.custom.bra_cup_size', 'filter.v.m.custom.bra_band_size'].forEach(name => {
      const filterList = document.querySelector(`input[name="${name}"]`)?.closest('.filter-group')?.querySelector('.collection-nav');
      if (!filterList) return;

      const items = Array.from(filterList.querySelectorAll('li'));
      const isExpanded = !items.some(item => item.classList.contains('hidden'));

      items.forEach((item, index) => {
        const hide = index >= 12 && !isExpanded;
        item.classList.toggle('hidden', hide);
        item.toggleAttribute('data-link-hidden', hide);
      });
    });
  }

  
  // Initialize size filter sorting on page load
  function initSizeFilterSorting() {
    sortSizeFilter();
    sortCupFilter();
    showTwelveInBraFilters();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeFilterSorting);
  } else {
    initSizeFilterSorting();
  }
  
  // Re-sort after filter updates (when collection sidebar is updated via AJAX)
  let sortTimeout;
  
  const debouncedSort = () => {
    clearTimeout(sortTimeout);
    sortTimeout = setTimeout(() => {
      sortSizeFilter();
      sortCupFilter();
      showTwelveInBraFilters();
    }, 200);
  };
  
  // Watch the sidebar container for when the entire filter group is replaced
  const sidebarObserver = new MutationObserver((mutations) => {
    let shouldSort = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // Only trigger if the filter-group--storrelse itself is added (full replacement)
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && 
              (node.classList?.contains('filter-group--storrelse') || 
               node.querySelector?.('.filter-group--storrelse'))) {
            shouldSort = true;
          }
        });
      }
    });
    if (shouldSort) {
      debouncedSort();
    }
  });
  
  // Observe the sidebar for structural changes
  const observeSidebar = () => {
    const sidebar = document.querySelector('[data-collection-sidebar]');
    if (sidebar) {
      sidebarObserver.observe(sidebar, { 
        childList: true,
        // Only watch direct children, not subtree
        subtree: false 
      });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSidebar);
  } else {
    observeSidebar();
  }
  
  // Also watch for when products finish loading (sidebar update is complete)
  const productsObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('is-loading') === false &&
          mutation.oldValue && mutation.oldValue.includes('is-loading')) {
        // Products finished loading, sidebar should be updated
        setTimeout(() => {
          observeSidebar();
          debouncedSort();
        }, 250);
      }
    });
  });
  
  const observeProducts = () => {
    const productsGrid = document.querySelector('[data-products-grid]');
    if (productsGrid) {
      productsObserver.observe(productsGrid, { 
        attributes: true, 
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProducts);
  } else {
    observeProducts();
  }

  /**
   * Preserve "show more" filter state across reloads
   * Only resets when drawer closes, never on filter selection/reload
   */
  (function() {
    const expandedFilters = new Set();
    
    const getFilterLabel = (group) => {
      const heading = group.querySelector('.filter-group__heading');
      if (!heading) return null;
      const firstSpan = heading.querySelector('span:first-child');
      return firstSpan?.textContent?.trim() || null;
    };
    
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-show-more]');
      if (!button) return;
      
      const filterGroup = button.closest('.filter-group');
      if (filterGroup) {
        const filterLabel = getFilterLabel(filterGroup);
        if (filterLabel) {
          expandedFilters.add(filterLabel);
        }
      }
    }, true);
    
    const restoreExpandedState = () => {
      if (expandedFilters.size === 0) return;
      
      queueMicrotask(() => {
        document.querySelectorAll('.filter-group').forEach((group) => {
          const filterLabel = getFilterLabel(group);
          if (filterLabel && expandedFilters.has(filterLabel)) {
            const actionsDiv = group.querySelector('.collection__sidebar__actions');
            if (!actionsDiv) return;
            
            actionsDiv.classList.add('hidden');
            
            const navList = actionsDiv.previousElementSibling;
            if (navList) {
              const hiddenLinks = navList.querySelectorAll('[data-link-hidden]');
              hiddenLinks.forEach((link) => {
                link.classList.remove('hidden');
              });
            }
          }
        });
      });
    };
    
    const resetAllFiltersToDefault = () => {
      const sidebar = document.querySelector('[data-collection-sidebar]');
      if (!sidebar) return;
      
      sidebar.querySelectorAll('.filter-group').forEach((group) => {
        const actionsDiv = group.querySelector('.collection__sidebar__actions');
        if (actionsDiv) {
          actionsDiv.classList.remove('hidden');
          const navList = actionsDiv.previousElementSibling;
          if (navList) {
            const hiddenLinks = navList.querySelectorAll('[data-link-hidden]');
            hiddenLinks.forEach((link) => {
              link.classList.add('hidden');
            });
          }
        }
      });
    };
    
    const observeSidebar = () => {
      const sidebar = document.querySelector('[data-collection-sidebar]');
      if (!sidebar) return;
      
      const observer = new MutationObserver(() => {
        restoreExpandedState();
      });
      
      observer.observe(sidebar, { childList: true, subtree: true });
    };
    
    document.addEventListener('theme:filter:close', () => {
      expandedFilters.clear();
      resetAllFiltersToDefault();
    });
    
    const drawerContainer = document.querySelector('.collection__sidebar__slide-out, [data-collection-sidebar]');
    if (drawerContainer) {
      const drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isExpanded = drawerContainer.classList.contains('expanded');
            if (!isExpanded && expandedFilters.size > 0) {
              expandedFilters.clear();
              resetAllFiltersToDefault();
            }
          }
        });
      });
      
      drawerObserver.observe(drawerContainer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    const productsGrid = document.querySelector('[data-products-grid]');
    if (productsGrid) {
      const productsObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && 
              mutation.attributeName === 'class' &&
              !mutation.target.classList.contains('is-loading') &&
              mutation.oldValue?.includes('is-loading')) {
            restoreExpandedState();
          }
        });
      });
      
      productsObserver.observe(productsGrid, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeSidebar);
    } else {
      observeSidebar();
    }
  })();

  // Temporary mega menu staying open always 
  // (function() {
  //   function keepFirstMenuOpen() {
  //     const allMenus = document.querySelectorAll('hover-disclosure');
  //     const firstMenu = allMenus[0]; // 6th menu (index 5)
  //     if (!firstMenu) return;
      
  //     // Override hideDisclosure to prevent closing
  //     if (!firstMenu._hideDisclosureOriginal) {
  //       firstMenu._hideDisclosureOriginal = firstMenu.hideDisclosure;
  //       firstMenu.hideDisclosure = function() {
  //         // Do nothing - prevent closing
  //       };
  //     }
      
  //     // Prevent hide events
  //     firstMenu.addEventListener('theme:disclosure:hide', (e) => {
  //       e.stopImmediatePropagation();
  //       e.preventDefault();
  //     }, true);
      
  //     // Force it open
  //     if (firstMenu.showDisclosure) {
  //       firstMenu.showDisclosure();
  //     }
      
  //     // Set attributes manually
  //     firstMenu.setAttribute('aria-expanded', 'true');
  //     firstMenu.classList.add('is-visible');
      
  //     const disclosureId = firstMenu.getAttribute('aria-controls');
  //     if (disclosureId) {
  //       const disclosure = document.getElementById(disclosureId);
  //       if (disclosure) {
  //         disclosure.classList.add('is-visible');
  //       }
  //     }
      
  //     // Also add meganav visible class if it's a grandparent
  //     const wrapper = firstMenu.closest('[data-header-wrapper]');
  //     if (wrapper && firstMenu.classList.contains('grandparent')) {
  //       wrapper.classList.add('meganav--visible');
  //     }
  //   }
    
  //   // Run on DOM ready
  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', keepFirstMenuOpen);
  //   } else {
  //     keepFirstMenuOpen();
  //   }
    
  //   // Re-run if menu is re-rendered
  //   const observer = new MutationObserver(() => {
  //     keepFirstMenuOpen();
  //   });
    
  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // })();

  /**
   * Mosaic Gallery (Desktop - 990px) – Show more / Show less toggle.
   * JS only handles the toggle interaction and smooth height animation.
   */
  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('[data-mosaic-toggle]');
    if (!toggleBtn) return;

    var gallery = toggleBtn.closest('[data-mosaic-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelector('[data-mosaic-slides]');
    if (!slides) return;

    var moreText = toggleBtn.querySelector('[data-mosaic-more-text]');
    var lessText = toggleBtn.querySelector('[data-mosaic-less-text]');
    var isCollapsed = gallery.classList.contains('is-collapsed');
    var duration = 500;

    if (isCollapsed) {
      // EXPAND: show hidden images with smooth animation
      var startHeight = slides.offsetHeight;
      gallery.classList.remove('is-collapsed');
      var endHeight = slides.scrollHeight;

      slides.style.height = startHeight + 'px';
      slides.style.overflow = 'hidden';
      requestAnimationFrame(function() {
        slides.style.transition = 'height ' + duration + 'ms cubic-bezier(0.4, 0, 0.2, 1)';
        requestAnimationFrame(function() {
          slides.style.height = endHeight + 'px';
          // Clean up after animation
          setTimeout(function() {
            slides.style.height = '';
            slides.style.overflow = '';
            slides.style.transition = '';
          }, duration + 50);
        });
      });

      if (moreText) moreText.style.display = 'none';
      if (lessText) lessText.style.display = '';
      toggleBtn.setAttribute('aria-expanded', 'true');
    } else {
      // COLLAPSE: smoothly clip images then hide when done
      var startHeight = slides.offsetHeight;

      // Measure collapsed height: briefly add class, measure, remove class (synchronous = no paint)
      gallery.classList.add('is-collapsed');
      var endHeight = slides.offsetHeight;
      gallery.classList.remove('is-collapsed');

      // Lock at expanded height, clip overflow
      slides.style.height = startHeight + 'px';
      slides.style.overflow = 'hidden';

      requestAnimationFrame(function() {
        slides.style.transition = 'height ' + duration + 'ms cubic-bezier(0.4, 0, 0.2, 1)';
        requestAnimationFrame(function() {
          slides.style.height = endHeight + 'px';
          // After animation finishes, add is-collapsed and clean up
          setTimeout(function() {
            gallery.classList.add('is-collapsed');
            slides.style.height = '';
            slides.style.overflow = '';
            slides.style.transition = '';
          }, duration + 50);
        });
      });

      if (moreText) moreText.style.display = '';
      if (lessText) lessText.style.display = 'none';
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // Handle responsive: collapse galleries when switching to desktop
  window.matchMedia('(min-width: 990px)').addEventListener('change', function(mq) {
    document.querySelectorAll('[data-mosaic-gallery]').forEach(function(gallery) {
      var moreText = gallery.querySelector('[data-mosaic-more-text]');
      var lessText = gallery.querySelector('[data-mosaic-less-text]');
      var toggleBtn = gallery.querySelector('[data-mosaic-toggle]');
      if (mq.matches) {
        gallery.classList.add('is-collapsed');
        if (moreText) moreText.style.display = '';
        if (lessText) lessText.style.display = 'none';
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        gallery.classList.remove('is-collapsed');
        var slides = gallery.querySelector('[data-mosaic-slides]');
        if (slides) {
          slides.style.height = '';
          slides.style.overflow = '';
          slides.style.transition = '';
        }
      }
    });
  });

  // ========== Product Delivery Block ==========
  document.addEventListener('theme:variant:change', function(e) {
    if (!e.detail || !e.detail.variant) return;
    var block = document.querySelector('[data-product-delivery]');
    if (!block) return;
    var isDelayed = (block.dataset.delayedVariants || '').indexOf(e.detail.variant.id + ',') > -1;
    block.querySelector('[data-delivery-normal]').hidden = isDelayed;
    block.querySelector('[data-delivery-delayed]').hidden = !isDelayed;
  });

  // ========== Cart Recommended Products ==========
  if (!customElements.get('cart-recommended-products')) {
    customElements.define('cart-recommended-products', class extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('slider-component');
        this.holdingArea = this.querySelector('[data-rec-holding]');
        this.limit = parseInt(this.dataset.limit) || 2;
        this.initArrows();
        this._onCartChange = () => this.refresh();
        document.addEventListener('theme:product:added', this._onCartChange);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:product:added', this._onCartChange);
      }

      initArrows() {
        this.querySelectorAll('.cart-recommended__arrow').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (!this.slider?.flkty) return;
            btn.dataset.direction === 'prev'
              ? this.slider.flkty.previous()
              : this.slider.flkty.next();
          });
        });
      }

      getProductId(el) {
        const holder = el.querySelector('[data-quick-add-holder]');
        return holder ? holder.getAttribute('data-quick-add-holder') : '';
      }

      refresh() {
        fetch(theme.routes.cart_url + '.js')
          .then((r) => r.json())
          .then((cart) => {
            const cartIds = new Set(cart.items.map((item) => String(item.product_id)));
            const flkty = this.slider?.flkty;
            if (!flkty) return;

            // Find visible cells that are now in the cart
            const toRemove = [];
            flkty.cells.forEach((cell) => {
              if (cartIds.has(this.getProductId(cell.element))) {
                toRemove.push(cell.element);
              }
            });

            // If nothing to change, return early
            if (toRemove.length === 0) return;

            // Remove cart products from Flickity (also removes from DOM)
            flkty.remove(toRemove);
            // Move removed elements to the holding area for potential future use
            toRemove.forEach((el) => this.holdingArea.appendChild(el));

            // Fill back to limit from holding area
            const needed = this.limit - flkty.cells.length;
            if (needed > 0) {
              const additions = [];
              const available = Array.from(this.holdingArea.querySelectorAll('quick-add-product'));
              for (const el of available) {
                if (additions.length >= needed) break;
                if (!cartIds.has(this.getProductId(el))) {
                  additions.push(el);
                }
              }
              if (additions.length > 0) {
                flkty.append(additions);
              }
            }
          })
          .catch((e) => console.error('Cart recommended:', e));
      }
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
